import Reveal from "react-reveal/Reveal";

import { useMedia } from "./media-queries";
import { HappyClientsContent } from "./HappyClientsContent";
import { Container } from "./styles";

export function HappyClientsSection({ years = 20, clients = 103 }) {
  const size = useMedia();

  return (
    <Reveal>
      <Container size={size}>
        <HappyClientsContent
          years={years}
          title={`We have over ${clients.toLocaleString("en-US")} happy clients.`}
          description="Description for the happy clients section"
        />
      </Container>
    </Reveal>
  );
}